import { useQuery } from "@tanstack/react-query";
import AdminService from "../../services/AdminService";

const useRepresentatives = () => {
  return useQuery({
    queryKey: ["representatives"],
    initialData: [],
    queryFn: async () => {
      const res = await AdminService.getRepresentatives();
      return res.representatives;
    },
  });
};

export default useRepresentatives;
